// This file is auto-generated. Edit data.graphql to change it.
import { DataProvider  } from 'Simple/Data'
import { useQuery } from 'Data/Api'
import useDataConfiguration from './useDataConfiguration'
import query from './data.graphql.js'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function DataVaxiomTxCardFieldDefinitionsListData(props) {
  let configuration = useDataConfiguration(props)
  let [{ data: rdata, fetching, error }, reExecuteQuery] = useQuery({ query, ...configuration })
  let data = rdata?.vaxiom_tx_card_field_definitions
  if (error || configuration.pause || fetching) return null

  return (
    <DataProvider
      context="tx_card_field_definitions"
      value={data}
      viewPath={props.viewPath}
    >
      <View {...props} />
    </DataProvider>
  )
}